import { searchArticlesByKnowledgeBaseId } from 'core_main/api/articles';
import { getOrFetchKnowledgeBaseId } from 'core_main/api/knowledge_bases';
import { getStore } from 'core_main/store';
import { PublicCallback } from 'globals/types';
import { handleError } from 'globals/errors';
import {
  createArticleCallbackResponse,
  createArticlesCallbackResponse,
} from '../get_articles/helpers';
import { SearchArticlesParameters } from './types';

export const runSearch = (searchParams, cb) => {
  return searchArticlesByKnowledgeBaseId(searchParams)
    .then((res) => {
      const articles = res.data.map((article) => {
        return createArticleCallbackResponse(article);
      });

      const callbackResponse = createArticlesCallbackResponse(articles);

      if (typeof cb === 'function') {
        cb(callbackResponse);
      }
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      handleError(error, { message: 'Failed to search articles' });
    });
};
export const searchArticles = (
  parameters: SearchArticlesParameters,
  cb?: PublicCallback,
) => {
  const store = getStore();
  const knowledgeBaseId =
    parameters?.knowledgeBaseId || store?.settings?.knowledgeBaseId;

  if (knowledgeBaseId) {
    return runSearch(
      {
        ...parameters,
        knowledgeBaseId,
      },
      cb,
    );
  }

  return getOrFetchKnowledgeBaseId().then((id) => {
    runSearch(
      {
        ...parameters,
        knowledgeBaseId: id,
      },
      cb,
    );
  });
};
